import styled from "styled-components";
import logo1 from "../assets/logo1.jpg";
import logo2 from "../assets/logo2.jpg";
import logo3 from "../assets/logo3.jpg";
import HomeImageCarousel from "../components/HomeImageCarousel";
import HomeLabelHeader from "../components/HomeLabelHeader";
import dompurify from "dompurify";
import {useEffect, useState} from "react";
import {fetchQuillData} from "../serverAPI";

const SanitizerInner = styled.div`
  text-align: justify;
  margin-bottom: 50px;

  span {
    line-height: 1.5em;
  }

  & img {
    max-width: 100%;
  }
`;

const MainImage = styled.img`
  width: 100%;
  height: auto;
`;

const IntroDescription = styled.p`
  padding: 34px 30px;
  padding-top: 0;
  font-size: 17px;
  line-height: 1.3;
  color: rgb(102, 102, 102);
`;

const IntroDescriptionSpan = styled.span`
  font-weight: bold;
`;

const HomeLaberlMainContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
`;

const HomeLabelContainer = styled.div`
  width: 315px;
`;

const LabelBold = styled.p`
  font-weight: bold;
  font-size: 13px;
  line-height: 1.5em;
`;

const LabelInner = styled.div`
  span {
    line-height: 1.5em;
  }
`;

const LabelMainText = styled.p`
  font-size: 13px;
  line-height: 1.5em;
`;

const LabelInnerRecentPublications = styled.div`
  word-wrap: break-word;

  span {
    line-height: 1.5em;
  }

  ul {
    list-style-type: initial;
    margin-left: 15px;
  }

  li {
    list-style-type: initial;

    &::marker {
      font-size: 11px;
    }
  }
`;

const LabelInnerNews = styled.div`
  word-wrap: break-word;

  span {
    line-height: 1.5em;
  }

  ul {
    list-style-type: initial;
    margin-left: 15px;
  }

  li {
    list-style-type: initial;

    &::marker {
      font-size: 11px;
    }
  }
`;

const LabelUl = styled.ul`
  list-style-type: initial;
  margin-left: 15px;
`;

const LabelLi = styled.li`
  list-style-type: initial;

  &::marker {
    font-size: 11px
  }
`;

const JustifyText = styled.p`
  text-align: justify;
  font-size: 13px;
  line-height: 1.5em;
`;

const LogoContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const BottomText = styled.p`
  font-size: 13px;
  line-height: 1.3em;
  color: rgb(102, 102, 102);
  text-align: right;
  margin-top: 10px;
  margin-bottom: 50px;
`;


export default function Home() {
  const sanitizer = dompurify.sanitize;
  const [homeMain, setHomeMain] = useState("");
  const [people, setPeople] = useState("");
  const [recentPublications, setRecentPublications] = useState("");
  const [labNews, setLabNews] = useState("");

  useEffect(() => {
    const loadHomeMainQuillData = async () => {
      const quillData = await fetchQuillData("homeMain");
      setHomeMain(quillData);
    };

    const loadPeopleQuillData = async () => {
      const quillData = await fetchQuillData("people");
      setPeople(quillData);
    };
    const loadRecentPublicationsQuillData = async () => {
      const quillData = await fetchQuillData("recentPublications");
      setRecentPublications(quillData);
    };
    const loadLabNewsQuillData = async () => {
      const quillData = await fetchQuillData("labNews");
      setLabNews(quillData);
    };

    loadHomeMainQuillData();
    loadPeopleQuillData();
    loadRecentPublicationsQuillData();
    loadLabNewsQuillData();
  }, []);

  return (<div>
    <SanitizerInner dangerouslySetInnerHTML={{__html: sanitizer(homeMain)}}/>
    {/*<MainImage src={homeImage} alt="MRI Lab"/>*/}
    {/*<IntroDescription>&nbsp; Broad research interests of magnetic resonance imaging (MRI) laboratory at Korea Advanced*/}
    {/*  Institute of Science*/}
    {/*  and Technology (KAIST) lie in <IntroDescriptionSpan>(i) developing new MRI techniques of image acquisition,*/}
    {/*    processing, and analysis,*/}
    {/*    (ii) revealing brain waste clearance pathway and mechanism through neurofluid MRI, (iii) applying deep learning*/}
    {/*    algorithms to MRI acceleration, image analysis and synthesis, and clinical*/}
    {/*    diagnosis.</IntroDescriptionSpan> These technical*/}
    {/*  developments*/}
    {/*  can make big differences in understanding baseline and functional brain physiology, and also diagnosis / prognosis*/}
    {/*  / treatment of our body.*/}
    {/*</IntroDescription>*/}
    <HomeImageCarousel/>
    <HomeLaberlMainContainer>
      <HomeLabelContainer>
        <HomeLabelHeader title="People" linkTo="/people"/>
        <LabelBold>New Graduate Students ------------------------------------)</LabelBold>
        <LabelInner
          dangerouslySetInnerHTML={{__html: sanitizer(people)}}/>
      </HomeLabelContainer>
      <HomeLabelContainer>
        <HomeLabelHeader title="Recent Publications" linkTo="/publications"/>
        <LabelInnerRecentPublications
          dangerouslySetInnerHTML={{__html: sanitizer(recentPublications)}}/>
      </HomeLabelContainer>
      <HomeLabelContainer>
        <HomeLabelHeader title="Lab News"/>
        <LabelInnerNews
          dangerouslySetInnerHTML={{__html: sanitizer(labNews)}}/>
      </HomeLabelContainer>
    </HomeLaberlMainContainer>
    <LogoContainer>
      <a href="https://www.kaist.ac.kr/" target="_blank">
        <img style={{width: "292px", height: "76px", marginTop: "15px"}} src={logo1} alt="kaist logo"/>
      </a>
      <a href="https://bioeng.kaist.ac.kr/" target="_blank">
        <img style={{width: "225px", height: "95px"}} src={logo2} alt="Bio and Brain Engineering logo"/>
      </a>
      <a href="https://bce.kaist.ac.kr/" target="_blank">
        <img style={{width: "291px", height: "92px", marginTop: "3px"}} src={logo3}
          alt="brain & congitive engeering logo"/>
      </a>
    </LogoContainer>
    <BottomText>
      Chung-Moon-Soul Building (E16 Building) 305-Ho, Department of Bio and Brain Engineering, KAIST,
      <br/>
      291, Daehak-ro, Yuseong-gu, Daejeon 34141, Republic of Korea
      <br/>
      Tel: +82-42-350-4352, Fax : +82-42-350-4310
    </BottomText>
  </div>);
}
